import axios, {AxiosError, AxiosInstance, AxiosRequestConfig, AxiosResponse, InternalAxiosRequestConfig} from 'axios';
import {authHeader} from "../helpers/authHeader";
import AuthClientStore from "../components/auth/AuthClientStore";
import {useContext} from "react";
import {AuthenticationHandler} from "../components/auth/AuthenticationHandler";
import {authService} from "./authService";

export const api_base_url: string = process.env.REACT_APP_API_BASEURL || '';
export const google_api_key: string = process.env.REACT_APP_GOOGLE_MAPS_API_KEY || '';
export const authorize_net_client_key: string = process.env.REACT_APP_AUTHORIZE_NET_CLIENT_KEY || '';
export const authorize_net_login_id: string = process.env.REACT_APP_AUTHORIZE_NET_LOGIN_ID || '';
export const authorize_net_accept_src = process.env.REACT_APP_ACCEPT_JS_URL || '';

let _refreshToken: () => Promise<void>;


//modified refresh system from 'https://dev.to/zenstok/part-23-how-to-implement-refresh-tokens-in-react-84c' and 'https://dev.to/charlintosh/setting-up-axios-interceptors-react-js-typescript-12k5'
export function registerRefreshToken(fn: () => Promise<void>) {
    _refreshToken = fn;
}
let isRefreshing = false;
const queue: {
    resolve: (value: string) => void;
    reject: (err: any) => void;
}[] = [];

function processQueue(error: any, token: string | null = null) {
    queue.forEach(p => {
        if (error) p.reject(error);
        else       p.resolve(token!);
    });
    queue.length = 0;
    isRefreshing = false;
}


const onRequest = async (config: InternalAxiosRequestConfig): Promise<InternalAxiosRequestConfig> => {
    const expiresAt = parseInt(AuthClientStore.getExpiresAt(), 10);
    if(config.url.includes('public') || config.url.includes('auth')){
        // public api routes. can ignore
        return config;
    }
    // if token is expired or about to expire:
    if (Date.now() > expiresAt - 10) {
        if (!isRefreshing) {
            isRefreshing = true;
            try {
                const response = await authService.refreshAccess(AuthClientStore.getRefreshToken());
                const { accessToken, refreshToken, expiresIn } = response;
                const now = Date.now();
                const expiresAt = now + expiresIn * 1000;
                AuthClientStore.setAccessToken(accessToken);
                AuthClientStore.setRefreshToken(refreshToken);
                AuthClientStore.setExpiresAt(expiresAt.toString());
                const newToken = AuthClientStore.getAccessToken();
                processQueue(null, newToken);
            } catch (err) {
                processQueue(err, null);
                console.log(err)
            }
        }

        // queue this request until the refresh is done:
        const token: string = await new Promise((resolve, reject) => {
            queue.push({resolve, reject});
        });

        config.headers!["Authorization"] = `Bearer ${token}`;
        return config;
    }
    
    if(config.url.includes('admin/')){
        config.headers!["Authorization"] = `Bearer ${AuthClientStore.getAccessToken()}`;
        return config;
    }

    // public route. no need for auth
    return config;
}

const onRequestError = (error: AxiosError): Promise<AxiosError> => {
    console.error(`[request error] [${JSON.stringify(error)}]`);
    return Promise.reject(error);
}

export function setupInterceptorsTo(axiosInstance: AxiosInstance): AxiosInstance {
    axiosInstance.interceptors.request.use(onRequest, onRequestError);
    //axiosInstance.interceptors.response.use(onResponse, onResponseError);
    return axiosInstance;
}
export const axiosInstance = setupInterceptorsTo(axios.create());
export const handleAxiosResponse = (res: AxiosResponse<any>): any => {
    const text = res.request.response || res.data;
    const type = res.headers['content-type'];
    if (
        typeof text === 'object' ||
        [
            'application/octet-stream',
            'application/text',
            'application/xlsx',
            'text/csv',
        ].includes(type)
    ) {
        return text;
    } else if (text) {
        return JSON.parse(text);
    } else {
        return 'No response';
    }
};
